import EntityTable from "@mirage/components/entityTable/EntityTable";
import LinkCell from "@mirage/components/entityTable/components/LinkCell";
import { Box } from "@mui/system";
import { GridColDef } from "@mui/x-data-grid-premium";
import EnforcementAppealsService from "@publicPortal/services/EnforcementAppealsService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import React, { memo, useCallback, useMemo } from "react";
import { SearchResultTableProps } from "./PlanningApplicationsTable";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { TablePaginationBaseProps } from "@mui/material/TablePagination";
import { useDeviceDetect } from "@mirage/hooks/useDeviceDetect";

const service = new EnforcementAppealsService();
const pp = new PublicPortalRoutingService();

const EnforcementAppealsTable: React.FC<SearchResultTableProps> = memo(({ filter, title, customPageRequest }) => {
    const { isMobile } = useDeviceDetect();
    const getRecordDetailRoute = useCallback((id: number) => pp.EnforcementAppealsRecordRoute(id), []);
    const onPageRequest = useCallback(
        async (pr: IEntityPageRequest) => {
            if (customPageRequest) {
                return await customPageRequest(pr);
            }
            const response = await service.pageRequest(pr);
            return response;
        },
        [customPageRequest]
    );
    const columns = useMemo((): GridColDef[] => {
        return [
            { field: "name", headerName: "Appeal Ref No.", renderCell: (params) => <LinkCell value={params.value} route={getRecordDetailRoute(Number(params.id))} />, width: 160 },
            { field: "appeal_type", headerName: "Appeal Type", width: 140 },
            { field: "appeal_level", headerName: "Appeal Level", width: 140 },
            { field: "date_started", headerName: "Date Started", type: "date", width: 140 },
        ];
    }, [getRecordDetailRoute]);
    const overridePaginationProps = useCallback((baseProps: TablePaginationBaseProps) => ({ ...baseProps, showFirstButton: false, showLastButton: false }), []);

    return (
        <Box sx={{ height: "auto" }}>
            <EntityTable
                title={title}
                key="enforcement-appeals-entityTable"
                stateKey="enforcementAppeals"
                onPageRequest={customPageRequest ? customPageRequest : onPageRequest}
                columns={columns}
                filter={filter}
                hideRowsPerPage={isMobile}
                overridePaginationProps={overridePaginationProps}
            />
        </Box>
    );
});

export default EnforcementAppealsTable;
